
export interface ViewProp{
    id: number,
    name: string,
    Vtype: ViewType,
    color: string,
    order: number,
    width: number | null,
    height: number | null
    autoOpened: boolean;
    classId: number | null,
    level: number | null,
    ipos: number | null,
    athleteid: number | null,
    maximized: boolean;
    fullheight: boolean;
    heightprocent: string;
    focused: boolean;
    isAutoPosition?: boolean;
    hideMenu?: boolean;
}



export enum ViewType {
    resultPretime = 1,
    result = 2,
    resultAnalytics = 3,
    scroll = 12,
    stage = 21,
    shooting = 31,
    speakerView = 41,
    athletebio = 61,
    athletebioTV = 62,
    teamdata = 70,
    coursemap = 80,
}